<template>
  <div class="app-container">
    <div v-if="!this.isMobileFlag">
      <v-header
        :showHeaderSearch="this.isShowSearch()"
        v-if="showHeader"
      ></v-header>
      <div :class="!showLeftSlider ? 'temp-center index' : 'temp-center'">
        <div class="content">
          <div class="content-wrap" style="width:100%">
            <asideNav v-if="showLeftSlider"></asideNav>
            <div :class="{ rightContent: showLeftSlider }">
              <router-view></router-view>
            </div>
            <advertCenter v-if="showPost"></advertCenter>
            <advert v-if="showAdvert"></advert>
            <!-- <div class="kPaMrk" v-if="showBottum">
              <a target="_blank"
                ><img
                  src="@/assets/images/activity/downpost.png"
                  alt=""
                  @click="gotoActivity()"
                  style="cursor: pointer;"
              /></a>
              <div>
                <div class="hdiJec" size="16" @click="changeButtom()">
                  <i class="el-icon-close" style="color: #fff;"></i>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="appLayout" v-else>
      <mheader v-if="showHeader"></mheader>
      <div class="content">
        <div class="content-wrap">
          <masideNav v-if="showLeftSlider"></masideNav>
          <div class="mrightContent">
            <div class="slider">
              <router-view></router-view>
            </div>
          </div>
          <advertCenter v-if="showPost"></advertCenter>
          <advert v-if="showAdvert"></advert>
        </div>
      </div>
    </div>
    <!-- <RightTip /> -->

    <!-- <Suspension /> -->
  </div>
</template>
<script>
import header from "@/components/header/header.vue";
import mheader from "@/components/header/mheader.vue";
import asideNav from "@/components/asideNav/asideNav.vue";
import masideNav from "@/components/asideNav/masideNav.vue";
import advert from "@/views/advert/advert";
import advertCenter from "@/views/advert/advertCenter";
import Suspension from "@/components/suspension/suspension.vue";
import RightTip from "@/components/righttip/righttip.vue";
import { getNewUser } from "../../utils/storage";
import { getMessageShow } from "../../api/auth";
export default {
  name: "app",
  components: {
    "v-header": header,
    asideNav,
    advert,
    advertCenter,
    mheader,
    masideNav,
    Suspension,
    RightTip,
  },
  computed: {
    showHeader() {
      return this.$store.state.common.showHeader;
    },
    showAdvert() {
      return this.$store.state.common.showAdvert;
    },
    showLeftSlider() {
      return this.$store.state.common.showLeftSlider;
    },
    showAllPage() {
      return this.$store.state.common.showAllPage;
    },
    showPost() {
      return this.$store.state.common.showPost;
    },
    showBottum() {
      return this.$store.state.common.showBottum;
    },
  },
  mounted() {
    if (this.isMobile()) {
      this.isMobileFlag = true;
    } else {
      this.isMobileFlag = false;
    }
    //this.isShowTip();
    this.$store.commit("updateShowAdvert", false);
  },
  data() {
    return {
      hasIndex: this.$store.state.menu.headerMenuId,
      isMobileFlag: false,
      isHeaderSearch: false,
      isShowButtom: false,
      isNewUser: false,
      isShowPost: false,
      arrowType: require("@/assets/images/activity/rightPop.png"),
    };
  },
  methods: {
    isShowTip() {
      this.isNewUser = getNewUser() != 0;
      this.isShowPost = this.$store.state.common.showPost;
      if (!this.isNewUser && !this.isShowPost) {
        //在不展示的时候 且不是新用户时
        getMessageShow({})
          .then((result) => {
            // if (this.$store.state.common.balanceIndex < result) {
            //   this.$store.commit("updateShowPost", true); //搜索页面
            //   this.$store.commit("updateBalanceIndex", result); //搜索页面
            // }
          })
          .catch((error) => {});
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    isShowSearch() {
      let flag = false;
      if (
        this.$store.state.common.userInfo.blance !== null &&
        this.$store.state.common.userInfo.blance > 0
      ) {
        flag = true;
      } else {
        flag = false;
      }
      return flag;
    },
    changeButtom() {
      this.$store.commit("updateShowBottum", false);
    },
    gotoActivity() {
      let routeUrl = this.$router.resolve({ path: "/11huodong" });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.appLayout {
  display: flex;
  .content {
    padding-right: 0;
    margin-top: 110px;
    display: flex;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
  }
}

.mrightContent {
  padding: 5px;
  //max-width: 1920px;
  min-width: 460px;
  width: calc(100vw - 360px);
  box-sizing: content-box;
  .silder {
    position: relative;
    width: 100%;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}

.temp-center {
  width: 100%;
  position: relative;
  // height: 100vh;
  overflow: auto;
  // background: #fff;
  background-color: #f9f8fb;
  padding-top: 70px;
  &.index {
    background: #fff;
    .content {
      margin-top: 0 !important;
    }
    .aside-nav {
      background: #f8f8fb;
    }
  }
  .content {
    padding-right: 0;
    // margin-top: 114px;
    display: flex;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
  }
}
.rightContent {
  // padding: 40px 90px 0 275px;
  //max-width: 1920px;
  padding: 20px;
  // padding-bottom: 100px;
  min-width: 560px;
  // width: calc(100vw - 360px);
  flex: 2;
  box-sizing: content-box;
  .silder {
    position: relative;
    width: 100%;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}
.wrapper div {
  height: 1rem;
}
.box1 {
  width: 2rem;
  background-color: coral;
}
.box2 {
  width: 4rem;
  background-color: skyblue;
}
.box3 {
  width: 6rem;
  background-color: palegreen;
}
.box4 {
  width: 8rem;
  background-color: wheat;
}
.box5 {
  width: 10rem;
  background-color: darkred;
}

.advert {
  float: contour;
  width: 100%;
  min-height: 50px;
  margin-bottom: 10px;
  .showImg {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.kPaMrk {
  position: fixed;
  bottom: 0px;
  width: 100vw;
  height: 80px;
  background-color: rgb(21, 93, 255);
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  z-index: 9999;
}

.kPaMrk div {
  position: absolute;
  top: 18px;
  right: 70px;
  cursor: pointer;
}

.hdiJec {
  display: inline-block;
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  font-size: 16px;
  position: relative;
  color: inherit;
  vertical-align: middle;
}

.content-wrap {
  display: flex;
}

.arrow {
  position: absolute;
  width: auto;
  right: 0%;
  bottom: 10%;
  transform: translate(-30%, -40%);
  text-align: center;
  animation-name: beat;
  /*动画名称*/
  animation-duration: 0.5s;
  /*设置秒数*/
  animation-timing-function: linear;
  /*速度曲线*/
  animation-iteration-count: infinite;
  /*播放次数*/
  animation-direction: alternate;
  /*逆向播放*/
  animation-play-state: running;
  /*正在运行*/
  cursor: pointer;
}
</style>
